var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.15002 2.45995H17.85C18.75 2.45995 19.48 3.18995 19.48 4.08995V20.2199C19.48 21.1199 18.75 21.85 17.85 21.85H6.15002C5.25002 21.85 4.52002 21.1199 4.52002 20.2199V4.07995C4.52002 3.17995 5.25002 2.44995 6.15002 2.44995V2.45995Z",
    fill: "#F0D4DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74997 1.5H14.26C14.69 1.5 15.04 1.85 15.04 2.28V3.62C15.04 4.05 14.69 4.4 14.26 4.4H9.74997C9.31997 4.4 8.96997 4.05 8.96997 3.62V2.28C8.96997 1.85 9.31997 1.5 9.74997 1.5V1.5Z",
    fill: "#B22651"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30001 9.76994C9.73631 9.76994 10.09 9.41625 10.09 8.97994C10.09 8.54364 9.73631 8.18994 9.30001 8.18994C8.8637 8.18994 8.51001 8.54364 8.51001 8.97994C8.51001 9.41625 8.8637 9.76994 9.30001 9.76994Z",
    fill: "#B22651"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.49 9.47998H11.26C10.98 9.47998 10.76 9.25998 10.76 8.97998C10.76 8.69998 10.98 8.47998 11.26 8.47998H15.49C15.77 8.47998 15.99 8.69998 15.99 8.97998C15.99 9.25998 15.77 9.47998 15.49 9.47998Z",
    fill: "#B22651"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30001 12.9399C9.73631 12.9399 10.09 12.5862 10.09 12.1499C10.09 11.7136 9.73631 11.3599 9.30001 11.3599C8.8637 11.3599 8.51001 11.7136 8.51001 12.1499C8.51001 12.5862 8.8637 12.9399 9.30001 12.9399Z",
    fill: "#B22651"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.49 12.6499H11.26C10.98 12.6499 10.76 12.4299 10.76 12.1499C10.76 11.8699 10.98 11.6499 11.26 11.6499H15.49C15.77 11.6499 15.99 11.8699 15.99 12.1499C15.99 12.4299 15.77 12.6499 15.49 12.6499Z",
    fill: "#B22651"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30001 16.11C9.73631 16.11 10.09 15.7563 10.09 15.32C10.09 14.8837 9.73631 14.53 9.30001 14.53C8.8637 14.53 8.51001 14.8837 8.51001 15.32C8.51001 15.7563 8.8637 16.11 9.30001 16.11Z",
    fill: "#B22651"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.49 15.8201H11.26C10.98 15.8201 10.76 15.6001 10.76 15.3201C10.76 15.0401 10.98 14.8201 11.26 14.8201H15.49C15.77 14.8201 15.99 15.0401 15.99 15.3201C15.99 15.6001 15.77 15.8201 15.49 15.8201Z",
    fill: "#B22651"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedTest);
export default __webpack_public_path__ + "static/media/selectedTest.63094dfb.svg";
export { ForwardRef as ReactComponent };